export const getDepartmentCollection = () => (
    [
        {id:1, title:"Ideas"},
        {id:2, title:"Icore"},
        {id:3, title:"Talent Transformation"},
        {id:4, title:"HR"},
        {id:5, title:"TopGear"}
    ]
)